import { apiGet, apiPost, apiDelete, unwrap } from './apiClient';
import type {
  ResponseDTO,
  AdeProfileDefineRequestDTO,
  AdeProfileDefineResponseDTO,
  AdeProfileResponseDTO,
  AdeProfileAssignRequestDTO,
  AdeProfileAssignResponseDTO,
} from '@/types/api';

const BASE = '/api/v1/ade/accounts';

export async function createAdeProfile(adeAccountId: string, body: AdeProfileDefineRequestDTO) {
  const res = await apiPost<ResponseDTO<AdeProfileDefineResponseDTO>>(
    `${BASE}/${adeAccountId}/profiles`,
    body,
    { includeTenantHeader: true }
  );
  return unwrap(res);
}

export async function listAdeProfiles(adeAccountId: string) {
  const res = await apiGet<ResponseDTO<AdeProfileResponseDTO[]>>(
    `${BASE}/${adeAccountId}/profiles`,
    { includeTenantHeader: true }
  );
  return unwrap(res);
}

export async function getAdeProfile(adeAccountId: string, profileId: string) {
  const res = await apiGet<ResponseDTO<AdeProfileResponseDTO>>(
    `${BASE}/${adeAccountId}/profiles/${profileId}`,
    { includeTenantHeader: true }
  );
  return unwrap(res);
}

export async function deleteAdeProfile(adeAccountId: string, profileId: string) {
  return apiDelete<ResponseDTO<null>>(
    `${BASE}/${adeAccountId}/profiles/${profileId}`,
    undefined,
    { includeTenantHeader: true }
  );
}

export async function assignProfileToDevices(
  adeAccountId: string,
  profileId: string,
  body: AdeProfileAssignRequestDTO
) {
  const res = await apiPost<ResponseDTO<AdeProfileAssignResponseDTO>>(
    `${BASE}/${adeAccountId}/profiles/${profileId}/devices`,
    body,
    { includeTenantHeader: true }
  );
  return unwrap(res);
}

export async function removeProfileFromDevices(
  adeAccountId: string,
  profileId: string,
  body: AdeProfileAssignRequestDTO
) {
  const res = await apiDelete<ResponseDTO<AdeProfileAssignResponseDTO>>(
    `${BASE}/${adeAccountId}/profiles/${profileId}/devices`,
    body,
    { includeTenantHeader: true }
  );
  return unwrap(res);
}
